import React from 'react'
import styled from 'styled-components'

const ContainerSection = styled.div<{ className: string  }>`
  display: flex;
  justify-content-center;
  align-items: center;
  width: 100%;

  ${p => p.className}
`
interface IOwnProps{
    className?: string
    children: any
}

const SectionFull: React.FunctionComponent<IOwnProps> = ({
    children,
    className = ''
}) => {
  return (
    <ContainerSection className={className}>
        {children}
    </ContainerSection>
  )
}

export default SectionFull